import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterSelecionados'
})
export class FilterSelecionadosPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) { return []; }
    if (!searchText) { return items; }

    searchText = searchText.toLowerCase();
    return items.filter(it => {
      if (it.nomeAvaliado) {
        return it.nomeAvaliado.toLowerCase().includes(searchText);
      } else  {
        return it.nome.toLowerCase().includes(searchText);
      }
    });
  }

}
